<template>
  <div :class="['row', teamClass, 'center-content']">
    <div class="col-2 offset-md-2 col-md-1 column table-cell--custom">
      <img :src="team.logo" class="team-logo" />
    </div>
    <div class="col-8 col-md-2 column table-cell--custom">
      <div class="col-12 table-cell--custom text-primary--custom">
        {{ teamName || team.name }}
      </div>
      <div class="col-12 table-cell--custom text-secondary--custom">
        {{ team.owner.firstName }} {{ team.owner.lastName }}
        <span class="d-md-none"> | {{ statuses[team.status] }}</span>
      </div>
      <div class="d-md-none col-12 table-cell--custom text-secondary--custom">
        In Play: {{ team.inPlay }} | Yet to Play: {{ team.playersRemaining }}
      </div>
    </div>
    <div class="col-2 col-md-1 column table-cell--custom">
      <div class="col-12 table-cell--custom text-primary--custom">
        {{ team.roundScore.toFixed(2) }}
      </div>
      <div class="d-sm-none col-12 table-cell--custom text-secondary--custom">
        {{ team.pointsFromSafety.toFixed(2) }}
      </div>
    </div>
    <div class="d-none d-md-block col-md-1 column table-cell--custom">
      {{ team.pointsFromSafety.toFixed(2) }}
    </div>
    <div class="d-none d-md-block col-md-1 column table-cell--custom">
      {{ team.inPlay }}
    </div>
    <div class="d-none d-md-block col-md-1 column table-cell--custom">
      {{ team.playersRemaining }}
    </div>
    <div class="d-none d-md-block col-md-1 column table-cell--custom">
      ${{ 100 - team.transactionCounter.acquisitionBudgetSpent }}
    </div>
    <div class="d-none d-md-block col-md-1 column table-cell--custom">
      {{ statuses[team.status] }}
    </div>
  </div>
</template>

<script lang="ts">
import { ref, PropType } from "vue";
import Team from '@/shared/teams/team';

export default {
  name: "StandingsRow",
  props: {
    team: {
      type: Object as PropType<Team>,
    }
  },
  setup(props: any) {
    const statuses = {
      0: "Out",
      1: "In Danger",
      2: "In For Now",
      3: "Safe",
    };

    const teamClass = ref<string>("");
    let teamName = "";

    if (props.team.name.length > 23 && screen.width < process.env.VUE_APP_WIDTH_PHONE_PORTRAIT) {
      teamName = props.team.name.substring(0,20) + '...';
    }


    if (props.team.status === 1) teamClass.value = "team--danger";
    else if (props.team.status === 4) teamClass.value = "team--out";

    return { statuses, teamClass, teamName };
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
.team-logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #f8f6e4;
  float: left;
}

.team--danger {
  opacity: 0.6;
}

.team--out {
  opacity: 0.3
}

.table-cell--custom {
  position: relative;
  text-align: left;
  padding: 0 !important;
}

.text-primary--custom {
  font-weight: bold;
}

.text-secondary--custom {
  font-size: 11px;
  color: $color-secondary-text;
}

@media screen and (min-width: $width-medium) {
  .table-cell--custom {
    position: relative;
    text-align: center;
    padding: 0 !important;
  }

  .text-primary--custom {
    font-weight: bold;
  }

  .text-secondary--custom {
    font-size: 11px;
    color: $color-secondary-text;
  }
}


@media screen and (min-width: $width-large) {
  .table-cell--custom {
    position: initial;
    text-align: inherit;
    padding: inherit;
  }

  .text-primary--custom {
    font-weight: bold;
  }

  .text-secondary--custom {
    font-size: initial;
    color: inherit;
  } 
}
</style>